// extracted by mini-css-extract-plugin
export default {"main":"nmoPE","icon":"vMto2"};